<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <value-class-create-or-update v-model="valueClass" :errors="errors"></value-class-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="createNew"
                    name="value-class"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    search></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import ShipableProductApi from '@/api/shipable-product'
import ValueClassCreateOrUpdate from './components/ValueClassCreateOrUpdate.vue'

export default {
    components:{
        BCard,
        ValueClassCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            errors:{},
            loading:false,
            valueClass:{
                Id:0,
                Name:null
            },
            fields:[
                { name:"Değer Sınıfı",key:"Name", thClass:"w-100",sortable:true,},
                
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.valueClass.Id = 0
            this.valueClass.Name = null
           
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.valueClass.Id = item.Id
            this.valueClass.Name = item.Name
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            ShipableProductApi.ValueClass.CreateOrUpdate(this.editing,this.valueClass)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
        },
        provider(data){
            return ShipableProductApi.ValueClass.Table(data)
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} değer sınıfı silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    ShipableProductApi.ValueClass.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>